import { Pipe, PipeTransform } from "@angular/core";
import { getRandom } from "../helpers/utils";
@Pipe({
  name: "strokeWidthRandom"
})
export class StrokeWidthRandomPipe implements PipeTransform {
  transform(value: any, strokeRandomValue: any): any {
    if (strokeRandomValue === true) {
      value = getRandom(0, 10);
    }
    return value;
  }
}
